import ensureArray from './ensureArray';
export default function arraysDoOverlap(arrA, arrB) {
    return ensureArray(arrA).some((item) => ensureArray(arrB).includes(item));
}
